import { useState } from 'react'
import { User } from 'interfaces/user'

export const useOrganizationAssignments = (internalAdmins: User[] = []) => {
  const [selectedAssignments, setSelectedAssignments] = useState<
    Record<string, { account_manager_user_id?: string; sale_rep_id?: string }>
  >({})

  const validUserIds = new Set(
    internalAdmins?.map((u) => u.id.toString()) || []
  )

  const handleAssignmentChange = (
    orgId: string,
    field: 'account_manager_user_id' | 'sale_rep_id',
    value: string
  ) => {
    setSelectedAssignments((prev) => ({
      ...prev,
      [orgId]: {
        ...prev[orgId],
        [field]: value,
      },
    }))
  }

  const isValidId = (id: unknown): boolean => {
    if (!id) return false
    const strId = String(id)
    return (
      strId !== '' &&
      strId !== '0' &&
      strId !== 'null' &&
      strId !== 'undefined' &&
      validUserIds.has(strId)
    )
  }

  const getSelectedId = (
    orgId: string,
    field: 'account_manager_user_id' | 'sale_rep_id',
    fallback: string | number | null | undefined
  ) => {
    const assigned = selectedAssignments[orgId]?.[field]
    if (assigned) return assigned

    // If there's a fallback value, use it regardless of validation
    // The validation will be handled in the styling
    if (fallback) {
      return fallback.toString()
    }

    return ''
  }

  const clearAssignment = (orgId: string) => {
    setSelectedAssignments((prev) => {
      const newState = { ...prev }
      delete newState[orgId]
      return newState
    })
  }

  return {
    selectedAssignments,
    validUserIds,
    handleAssignmentChange,
    isValidId,
    getSelectedId,
    clearAssignment,
  }
}
